














































































































import { Component, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import Toast from '@/app/components/Common/Toast.vue'
/* api */
import LoginApi from '@/app/model/api/loginApi'
/* module */
import Validator from '@/app/module/validator'
import { routerPath } from '@/app/model/store/domain/const'
import Local from '@/app/module/local'

@Component({
  components: {
    CommonHeader,
    Toast
  }
})
export default class Login extends Vue {
  private email: string = ''
  private password: string = ''
  private errorMessages: any = ''
  private toastMessage: string = ''
  private showAlert: boolean = false

  created () {
    Local.setReminderFlag(false)
    Local.setResettingFlag(false)
    this.$store.commit('routeState/setRoute', this.$route.path)
  }

  private async login () {
    /* ログイン処理が成功したらfieldへ遷移、失敗したらアラートを表示 */
    if (this.isLogin()) {
      const bodyData = {
        'mailaddress': this.email,
        'password': this.password
      }

      const result = await LoginApi.doLogin(bodyData)
      if (result.isOk()) {
        this.$router.push(routerPath.PATH_FIELD)
      } else if (result.checkTimeoutErrorStatus()) {
        this.$store.commit('routeState/setTimeoutErrorFlag', true)
        this.$store.commit('routeState/setErrorFlag', false)
        this.$router.push(routerPath.PATH_ERROR_PAGE)
      } else if (result.getPayload().status_code === 'E0001' ||
                 result.getPayload().status_code === 'E0002') {
        // メールアドレスまたはパスワード間違えの場合
        this.toastMessage = 'メールアドレスまたはパスワードが違うため、ログインできませんでした。'
        this.showAlert = true
      } else if (result.checkErrorStatus()) {
        this.$store.commit('routeState/setErrorFlag', true)
        this.$router.push(routerPath.PATH_ERROR_PAGE)
      } else {
        this.toastMessage = result.getPayload().message
        this.showAlert = true
      }
    }
  }

  private isLogin () {
    const emailFlag = Validator.validateInputEmail('emailErrorMessage', this.email)
    const passwordFlag = Validator.validateInputPassword('passwordErrorMessage', this.password)

    this.errorMessages = Validator.getErrorMessage()

    return emailFlag && passwordFlag
  }

  private closeAlert () {
    this.showAlert = false
    this.password = ''
  }
}
